import 'react';
import { Box, LoadingSpinner, Text, Glyphicon } from 'reaxl';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function RatesTable(_ref) {
  let {
    ratesData,
    selectedLoanTerm,
    isLoading
  } = _ref;
  // Don't show anything if not loading and insufficient data
  if (!isLoading && (!ratesData || ratesData.length < 2)) return null;
  const ratesDataCopy = [...(ratesData || [])].sort((a, b) => b.rate - a.rate);
  const {
    name: lenderName,
    rate: rateValue
  } = ratesDataCopy.pop() || {};
  const rates = ratesDataCopy.slice(0, 4).map(rate => ({
    ...rate,
    rateDifference: (rate.rate - rateValue).toFixed(2)
  }));
  const lowestRate = rates[rates.length - 1]?.rate;
  const highestRate = rates[0]?.rate;
  const hasMultipleComparableRates = rates.length > 1;
  const renderRateComparison = () => {
    if (hasMultipleComparableRates) {
      return /*#__PURE__*/jsxs(Fragment, {
        children: ["while comparable lenders are offering rates between", ' ', /*#__PURE__*/jsxs(Text, {
          componentClass: "span",
          color: "danger",
          children: [lowestRate, "%"]
        }), ' and ', /*#__PURE__*/jsxs(Text, {
          componentClass: "span",
          color: "danger",
          children: [highestRate, "%"]
        })]
      });
    }
    return /*#__PURE__*/jsxs(Fragment, {
      children: ["while the next comparable lender is offering a rate of", ' ', /*#__PURE__*/jsxs(Text, {
        componentClass: "span",
        color: "danger",
        children: [lowestRate, "%"]
      })]
    });
  };
  return /*#__PURE__*/jsx(Box, {
    className: "text-size-200 margin-top-2 margin-top-sm-3",
    backgroundColor: "brand-tertiary",
    "data-cmp": "ratesComparisonTable",
    children: isLoading ? /*#__PURE__*/jsx("div", {
      className: "display-flex align-items-center justify-content-center",
      children: /*#__PURE__*/jsx(LoadingSpinner, {
        className: "margin-0"
      })
    }) : /*#__PURE__*/jsxs("div", {
      className: "display-flex align-items-center",
      children: [/*#__PURE__*/jsx(Text, {
        color: "blue-darker",
        className: "margin-right-2 align-self-start",
        size: 500,
        children: /*#__PURE__*/jsx(Glyphicon, {
          glyph: "sparkles"
        })
      }), /*#__PURE__*/jsxs(Text, {
        componentClass: "div",
        color: "blue-darker",
        children: [lenderName, ' is offering a rate of ', /*#__PURE__*/jsxs(Text, {
          componentClass: "span",
          weight: "bold",
          children: [rateValue, "%"]
        }), ` for ${selectedLoanTerm} months, `, renderRateComparison(), "."]
      })]
    })
  });
}
export { RatesTable as default };
